import React from "react";

const EditIcon = ({ fill = '#919293' }) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <path
      d="M4.60935 11.7C4.63602 11.7 4.66269 11.6974 4.68935 11.6934L6.93202 11.3C6.95869 11.2947 6.98402 11.2827 7.00269 11.2627L12.6547 5.61069C12.667 5.59835 12.6769 5.5837 12.6835 5.56757C12.6902 5.55144 12.6937 5.53415 12.6937 5.51669C12.6937 5.49922 12.6902 5.48193 12.6835 5.4658C12.6769 5.44967 12.667 5.43502 12.6547 5.42269L10.4387 3.20535C10.4134 3.18002 10.38 3.16669 10.344 3.16669C10.308 3.16669 10.2747 3.18002 10.2494 3.20535L4.59735 8.85735C4.57735 8.87735 4.56535 8.90135 4.56002 8.92802L4.16669 11.1707C4.15372 11.2421 4.15835 11.3156 4.18019 11.3849C4.20203 11.4541 4.24041 11.517 4.29202 11.568C4.38002 11.6534 4.49069 11.7 4.60935 11.7ZM5.50802 9.37469L10.344 4.54002L11.3214 5.51735L6.48535 10.352L5.30002 10.5614L5.50802 9.37469ZM12.9067 12.82H3.09335C2.85735 12.82 2.66669 13.0107 2.66669 13.2467V13.7267C2.66669 13.7854 2.71469 13.8334 2.77335 13.8334H13.2267C13.2854 13.8334 13.3334 13.7854 13.3334 13.7267V13.2467C13.3334 13.0107 13.1427 12.82 12.9067 12.82Z"
      fill={fill}
    />
  </svg>
);

export default EditIcon;
